import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Stamp } from 'models';

export interface StampsState extends EntityState<Stamp, number> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'stamps', resettable: true })
export class StampsStore extends EntityStore<StampsState> {
  constructor() {
    super();
  }
}
